// extracted by mini-css-extract-plugin
export var box = "_3t-0";
export var check = "_3t-1";
export var checkboxButton = "_3t-6";
export var checkboxGroup = "_3t-5";
export var disabled = "_3t-7";
export var ghost = "_3t-9";
export var input = "_3t-2";
export var label = "_3t-4";
export var normal = "_3t-8";
export var uncheck = "_3t-3";